module.exports = __webpack_public_path__ + "img/news_2.c4e85c3d.png";